import * as Sentry from '@sentry/react';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  removeContextGraphEntity,
  removeContextGraphFact,
} from '@/services/context-graphs/remove-from-context-graph';

export interface RemoveContextGraphItemInput {
  graphId: string;
  kind: 'entity' | 'fact';
  id: string;
}

export const useRemoveContextGraphItem = (
  options?: Omit<
    UseMutationOptions<unknown, Error, RemoveContextGraphItemInput>,
    'mutationFn'
  >,
) => {
  return useMutation({
    ...options,
    mutationFn: ({ graphId, kind, id }: RemoveContextGraphItemInput) =>
      kind === 'entity'
        ? removeContextGraphEntity(graphId, id)
        : removeContextGraphFact(graphId, id),
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: {
          context: 'remove-context-graph-item',
          graphId: variables.graphId,
          kind: variables.kind,
        },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
